import { render, staticRenderFns } from "./Comentario.vue?vue&type=template&id=e23b1314&scoped=true"
import script from "./Comentario.vue?vue&type=script&lang=js"
export * from "./Comentario.vue?vue&type=script&lang=js"
import style0 from "./Comentario.vue?vue&type=style&index=0&id=e23b1314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23b1314",
  null
  
)

export default component.exports